import numberToPersian from "./NumberToPersian";
import axiosConfig from "./axiosConfig";

const SabbatRefereeSideInfo = (props) => {
  const fullname_red = props.athleteFullname.fullname_red;
  const fullname_blue = props.athleteFullname.fullname_blue;
  const playcode = props.playCode;
  const round = props.roundNumber;
  const totalData = props.totalData;
  let getTotalWinner = props.getTotalWinner;

  let roundA = "";
  let roundB = "";
  let roundC = "";
  let totalRound = "";
  let winner = "";

  let blue_point = 0;
  let red_point = 0;

  if (totalData.round_a_winner === "blue") {
    roundA = "bg-primary";
    blue_point += 1;
  } else if (totalData.round_a_winner === "red") {
    roundA = "bg-danger";
    red_point += 1;
  } else if (totalData.round_a_winner === "white") {
    roundA = "bg-secondary";
  } else {
    roundA = "";
  }

  if (totalData.round_b_winner === "blue") {
    roundB = "bg-primary";
    blue_point += 1;
  } else if (totalData.round_b_winner === "red") {
    roundB = "bg-danger";
    red_point += 1;
  } else if (totalData.round_b_winner === "white") {
    roundB = "bg-secondary";
  } else {
    roundB = "";
  }

  if (totalData.round_c_winner === "blue") {
    roundC = "bg-primary";
    blue_point += 1;
  } else if (totalData.round_c_winner === "red") {
    roundC = "bg-danger";
    red_point += 1;
  } else if (totalData.round_c_winner === "white") {
    roundC = "bg-secondary";
  } else {
    roundC = "";
  }

  if (blue_point > red_point) {
    winner = "blue";
  } else if (red_point > blue_point) {
    winner = "red";
  }

  if (getTotalWinner === "blue") {
    totalRound = "bg-primary";
  } else if (getTotalWinner === "red") {
    totalRound = "bg-danger";
  } else if (getTotalWinner === "white") {
    totalRound = "bg-secondary";
  } else {
    totalRound = "";
  }

  return (
    <div
      className="col-md-2 col-sm-12 text-center"
      style={{ textAlign: "right", direction: "rtl" }}
    >
      <div className="row match-brief">
        <div
          className="col-12 mt-3 IRANSansNormal"
          style={{ textAlign: "right", fontSize: "13px", lineHeight: "2em" }}
        >
          <div>
            <span
              className="badge bg-danger"
              style={{ fontSize: "13px", display: "block" }}
            >
              {fullname_red}
            </span>
            <span
              className="badge bg-primary mt-1"
              style={{ fontSize: "13px", display: "block" }}
            >
              {fullname_blue}
            </span>
          </div>
          <div className="row mt-2">
            <div className="col-6">شماره بازی: </div>
            <div
              className="col-6"
              style={{ textAlign: "left", direction: "ltr" }}
            >
              <strong>{numberToPersian(totalData.playnumber)}</strong>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6">وزن: </div>
            <div
              className="col-6"
              style={{ textAlign: "left", direction: "ltr" }}
            >
              <strong>{totalData.weight} Kg</strong>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6">کد بازی: </div>
            <div
              className="col-6"
              style={{ textAlign: "left", direction: "ltr" }}
            >
              <strong>{numberToPersian(playcode)}</strong>
            </div>
          </div>

          <div className="row">
            <div className="col-6">راند شماره: </div>
            <div
              className="col-6"
              style={{ textAlign: "left", direction: "ltr" }}
            >
              <strong>{numberToPersian(round)}</strong>
            </div>
          </div>
          <div className="row">
            <div className="col-6">تذکر: </div>
            <div
              className="col-6"
              style={{ textAlign: "left", direction: "ltr" }}
            >
              <span className="badge bg-danger">
                {numberToPersian(totalData.notice_red)}
              </span>{" "}
              &nbsp;
              <span className="badge bg-primary">
                {numberToPersian(totalData.notice_blue)}
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col-6">اخطار: </div>
            <div
              className="col-6"
              style={{ textAlign: "left", direction: "ltr" }}
            >
              <span className="badge bg-danger">
                {numberToPersian(totalData.foal_red)}
              </span>{" "}
              &nbsp;
              <span className="badge bg-primary">
                {numberToPersian(totalData.foal_blue)}
              </span>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-6">اخطار (کل): </div>
            <div
              className="col-6"
              style={{ textAlign: "left", direction: "ltr" }}
            >
              <span className="badge bg-danger">
                {numberToPersian(totalData.foal_total_red)}
              </span>{" "}
              &nbsp;
              <span className="badge bg-primary">
                {numberToPersian(totalData.foal_total_blue)}
              </span>
            </div>
          </div> */}
          <div className="row">
            <div className="col-6">بیرون: </div>
            <div
              className="col-6"
              style={{ textAlign: "left", direction: "ltr" }}
            >
              <span className="badge bg-danger">
                {numberToPersian(totalData.out_red)}
              </span>{" "}
              &nbsp;
              <span className="badge bg-primary">
                {numberToPersian(totalData.out_blue)}
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col-6">ناک دان: </div>
            <div
              className="col-6"
              style={{ textAlign: "left", direction: "ltr" }}
            >
              <span className="badge bg-danger">
                {" "}
                {numberToPersian(totalData.ndown_red)}
              </span>{" "}
              &nbsp;
              <span className="badge bg-primary">
                {" "}
                {numberToPersian(totalData.ndown_blue)}
              </span>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-6">ناک دان (کل): </div>
            <div
              className="col-6"
              style={{ textAlign: "left", direction: "ltr" }}
            >
              <span className="badge bg-danger">
                {" "}
                {numberToPersian(totalData.ndown_total_red)}
              </span>{" "}
              &nbsp;
              <span className="badge bg-primary">
                {" "}
                {numberToPersian(totalData.ndown_total_blue)}
              </span>
            </div>
          </div> */}
          <div className="row">
            <div className="col-6">زمین خوردن: </div>
            <div
              className="col-6"
              style={{ textAlign: "left", direction: "ltr" }}
            >
              <span className="badge bg-danger">
                {numberToPersian(totalData.ground_red)}
              </span>{" "}
              &nbsp;
              <span className="badge bg-primary">
                {numberToPersian(totalData.ground_blue)}
              </span>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-8">راند اول: </div>
            <div
              className="col-4"
              style={{ textAlign: "left", direction: "ltr" }}
            >
              <div className={"winner-round " + roundA}>&nbsp;</div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-8">راند دوم: </div>
            <div
              className="col-4"
              style={{ textAlign: "left", direction: "ltr" }}
            >
              <div className={"winner-round " + roundB}>&nbsp;</div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-8">راند سوم: </div>
            <div
              className="col-4"
              style={{ textAlign: "left", direction: "ltr" }}
            >
              <div className={"winner-round " + roundC}>&nbsp;</div>
            </div>
          </div>
          <div className="row mt-2 final-point">
            <div className="col-8">برنده نهایی: </div>
            <div
              className="col-4"
              style={{ textAlign: "left", direction: "ltr" }}
            >
              <div className={"winner-round " + totalRound}>&nbsp;</div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default SabbatRefereeSideInfo;
